<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled
  flat

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder

      if (this.value.value) {
        this.items.push(this.value);
        this.select = this.value;
      }
    });
  },

  watch: {
    search(val) {
      if (!val) {
        this.clearPending();
        this.loading = false;
        this.items = this.select && typeof this.select === "object" ? [this.select] : [];
        return;
      }

      const selectedText = this.select && typeof this.select === "object" ? this.select.text : this.select;
      if (selectedText && val === selectedText) {
        return;
      }

      this.querySelections(val);
    }
  },

  beforeDestroy() {
    this.clearPending();
  },

  methods: {
    clearPending() {
      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.requestSeq = (this.requestSeq || 0) + 1;

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }
    },

    querySelections(value) {
      this.clearPending();

      if (!this.geocoder) {
        this.loading = false;
        return;
      }

      const seq = this.requestSeq;
      this.loading = true;

      this.timeout = setTimeout(() => {
        this.timeout = null;

        this.geocoder.autocomplete(value).then(items => {
          if (seq !== this.requestSeq) {
            return;
          }
          this.items = items.slice();
        }).catch(() => {
          if (seq !== this.requestSeq) {
            return;
          }
          this.items = [];
        }).finally(() => {
          if (seq === this.requestSeq) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.clearPending();
      this.loading = false;
      this.$emit("change", o);
    }
  }
};
</script>
